module.exports = function() {
  return new Worker(__webpack_public_path__ + "423524ecefa7e246be43.worker.js");
};